// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SocketSelector_container__TKQ5b {
  display: flex;
  flex-wrap: wrap;
  align-content: start;
  gap: 1rem;
  row-gap: 0.5rem;
  padding: 0px;
  margin: 0px;
}

.SocketSelector_socket__ltnfl {
  width: calc(25% - 1rem);
  display: flex;
  min-width: fit-content;
  gap: 0.5rem;
  row-gap: 0px;
  align-items: center;
}
@media screen and (max-width: 991px) {
  .SocketSelector_socket__ltnfl {
    flex-direction: column;
  }
}
.SocketSelector_socket__ltnfl label {
  vertical-align: top;
  margin: 0px;
}`, "",{"version":3,"sources":["webpack://./src/components/Misc/SocketSelector.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,eAAA;EACA,oBAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;AACF;;AAEA;EACE,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AACF;AACE;EARF;IASI,sBAAA;EAEF;AACF;AAAE;EACE,mBAAA;EACA,WAAA;AAEJ","sourcesContent":[".container {\n  display: flex;\n  flex-wrap: wrap;\n  align-content: start;\n  gap: 1rem;\n  row-gap: 0.5rem;\n  padding: 0px;\n  margin: 0px;\n}\n\n.socket {\n  width: calc(25% - 1rem);\n  display: flex;\n  min-width: fit-content;\n  gap: 0.5rem;\n  row-gap: 0px;\n  align-items: center;\n}\n@media screen and (max-width: 991px) {\n  .socket {\n    flex-direction: column;\n  }\n}\n.socket label {\n  vertical-align: top;\n  margin: 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SocketSelector_container__TKQ5b`,
	"socket": `SocketSelector_socket__ltnfl`
};
export default ___CSS_LOADER_EXPORT___;
